import * as Client from 'api/client';

export async function getClientProfiles(liff) {
  try {
    const profile = await liff.getProfile();
    if (!profile) return { error: true };

    const userId = profile.userId;
    const accessToken = liff.getAccessToken();
    const customer = await Client.getCustomerForm(userId, accessToken);
    if (customer.err) return { error: customer.message };

    const client = { ...profile, ...customer };
    if (!client.name) client.name = profile.displayName;

    return { client, profile, accessToken, userId };
  } catch (error) {
    return { error };
  }
}
